import { useRef, type ReactNode } from 'react';
import logo from '../../assets/ui/brand/logo-horizontal.png';
import { syncOwner } from '../../sync/browser-sync';
import { useAccount } from './useAccount';
import './account-gate.css';

export function AccountGate({ children }: { children: (account: ReturnType<typeof useAccount>) => ReactNode }) {
  const account = useAccount();
  const mounted = useRef(false);
  const owner = syncOwner();
  const mismatch = !!account.userId && !!owner && owner !== account.userId;
  const allowed = !!account.userId && !mismatch;
  if (allowed) mounted.current = true;
  return <>
    {mounted.current && <div hidden={!allowed} inert={!allowed}>{children(account)}</div>}
    {!allowed && <main className="account-gate">
      <section className="account-gate-card" aria-labelledby="account-gate-title">
        <img src={logo} alt="YumNote" />
        <h1 id="account-gate-title">{mismatch ? 'Нужен прежний аккаунт' : 'Вход в YumNote'}</h1>
        {mismatch ? <p>Данные этого устройства связаны с другим аккаунтом VK. Выйдите и войдите в прежний аккаунт. Записи остаются на устройстве.</p> : <p>Войдите через VK ID, чтобы пользоваться приложением. Ваши сохранённые записи останутся на устройстве.</p>}
        {account.error && <p role="alert">{account.error} Данные на устройстве не удалены.</p>}
        {account.busy && <p role="status">Проверяем вход…</p>}
        {mismatch ? <button disabled={account.busy} onClick={() => void account.logout()}>Выйти из аккаунта</button> : <button disabled={account.busy} onClick={() => void account.login()}>Войти через VK ID</button>}
        {!mismatch && account.error && <button className="account-gate-secondary" disabled={account.busy} onClick={() => void account.retry()}>Повторить проверку</button>}
      </section>
    </main>}
  </>;
}
